module.exports = __webpack_public_path__ + "static/media/LinkedIn fav.a08f59f4.png";